'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { ElementRef, forwardRef, Fragment, ReactNode } from 'react';

interface DualRangeSliderProps
  extends React.ComponentProps<typeof SliderPrimitive.Root> {
  labelPosition?: 'top' | 'bottom';
  label?: (value: number | undefined) => ReactNode;
}

const DualRangeSlider = forwardRef<
  ElementRef<typeof SliderPrimitive.Root>,
  DualRangeSliderProps
>(({ className, label, labelPosition = 'top', ...props }, ref) => {
  const initialValue = Array.isArray(props.value)
    ? props.value
    : [props.min, props.max];

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={
        'relative flex w-full touch-none select-none items-center ' + className
      }
      {...props}
    >
      <SliderPrimitive.Track className="relative h-4 w-full grow overflow-hidden rounded-full bg-secondary">
        <SliderPrimitive.Range className="absolute h-full bg-primary " />
      </SliderPrimitive.Track>
      {initialValue.map((value, index) => (
        <Fragment key={index}>
          <SliderPrimitive.Thumb className="relative block h-4 w-4 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
            {label && (
              <span
                className={`absolute flex w-full justify-center 
                  ${labelPosition === 'top' && '-top-7'} 
                  ${labelPosition === 'bottom' && 'top-4'}`}
              >
                {label(value)}
              </span>
            )}
          </SliderPrimitive.Thumb>
        </Fragment>
      ))}
    </SliderPrimitive.Root>
  );
});
DualRangeSlider.displayName = 'DualRangeSlider';

export default DualRangeSlider;
